/**
 * 邮件模板占位符类型常量
 * 确保前后端类型关键字的一致性
 */

// 占位符类型枚举
export const CONTENT_BLOCK_TYPES = {
    // 航班相关
    FLIGHT_INFO: "flightInfo",
    FLIGHT_LIST: "flightList",
    FLIGHT_SCHEDULE: "flightSchedule",

    // 航班计划相关
    SCHEDULE_FLIGHT_LIST: "scheduleFlightList",
    SCHEDULE_FLIGHT_LIST_WITH_COMPARISON: "scheduleFlightListWithComparison",
    SCHEDULE_INFO: "scheduleInfo",

    // 执行航班相关
    OPERATION_FLIGHT_LIST: "operationFlightList",
    FLIGHT_WITH_PREDECESSOR: "flightWithPredecessor",

    // 通用内容
    CONTENT_BLOCK: "contentBlock",
    SIGNATURE: "signature",
};

// 占位符类型到业务上下文键的映射
export const CONTENT_BLOCK_TO_CONTEXT_MAP = {
    [CONTENT_BLOCK_TYPES.FLIGHT_INFO]: "flights",
    [CONTENT_BLOCK_TYPES.FLIGHT_LIST]: "flights",
    [CONTENT_BLOCK_TYPES.FLIGHT_SCHEDULE]: "schedule",
    [CONTENT_BLOCK_TYPES.SCHEDULE_FLIGHT_LIST]: "flights",
    [CONTENT_BLOCK_TYPES.SCHEDULE_FLIGHT_LIST_WITH_COMPARISON]: "scheduleFlightComparison",
    [CONTENT_BLOCK_TYPES.SCHEDULE_INFO]: "schedule",
    [CONTENT_BLOCK_TYPES.OPERATION_FLIGHT_LIST]: "operationFlights",
    [CONTENT_BLOCK_TYPES.FLIGHT_WITH_PREDECESSOR]: "flightWithPredecessor",
    [CONTENT_BLOCK_TYPES.CONTENT_BLOCK]: "content",
    [CONTENT_BLOCK_TYPES.SIGNATURE]: "user",
};

// 占位符类型的显示配置
export const CONTENT_BLOCK_DISPLAY_CONFIG = {
    [CONTENT_BLOCK_TYPES.FLIGHT_INFO]: {
        label: "航班信息",
        icon: "✈️",
        color: "#1890ff",
        description: "插入单个航班的详细信息",
    },
    [CONTENT_BLOCK_TYPES.FLIGHT_LIST]: {
        label: "航班列表",
        icon: "📋",
        color: "#1890ff",
        description: "插入航班列表表格",
    },
    [CONTENT_BLOCK_TYPES.FLIGHT_SCHEDULE]: {
        label: "航班计划",
        icon: "📅",
        color: "#1890ff",
        description: "插入航班计划概要",
    },
    [CONTENT_BLOCK_TYPES.CONTENT_BLOCK]: {
        label: "内容块",
        icon: "📝",
        color: "#8c8c8c",
        description: "插入自定义内容块",
    },
    [CONTENT_BLOCK_TYPES.SCHEDULE_FLIGHT_LIST]: {
        label: "航班计划列表",
        icon: "📋",
        color: "#1890ff",
        description: "插入航班计划中的航班列表",
    },
    [CONTENT_BLOCK_TYPES.SCHEDULE_FLIGHT_LIST_WITH_COMPARISON]: {
        label: "计划航班列表（含对比）",
        icon: "📊",
        color: "#fa541c",
        description: "插入计划航班列表，包含对比结果和删除的执行航班标记",
    },
    [CONTENT_BLOCK_TYPES.SCHEDULE_INFO]: {
        label: "计划基本信息",
        icon: "📅",
        color: "#52c41a",
        description: "插入航班计划的基本信息",
    },
    [CONTENT_BLOCK_TYPES.OPERATION_FLIGHT_LIST]: {
        label: "执行航班列表",
        icon: "🛫",
        color: "#1890ff",
        description: "插入执行航班列表表格，用于事务申请邮件",
    },
    [CONTENT_BLOCK_TYPES.FLIGHT_WITH_PREDECESSOR]: {
        label: "航班及前序航班",
        icon: "🔗",
        color: "#722ed1",
        description: "插入当前航班及其前序航班的详细信息表格，用于航食申请邮件",
    },
    [CONTENT_BLOCK_TYPES.SIGNATURE]: {
        label: "签名",
        icon: "✍️",
        color: "#595959",
        description: "插入用户签名",
    },
};

// 内容块示例数据配置
export const CONTENT_BLOCK_SAMPLE_DATA = {
    [CONTENT_BLOCK_TYPES.FLIGHT_INFO]: {
        flightNumber: "CA1234",
        aircraft: "B737-800",
        route: "PEK → SHA",
        departureTime: "08:30",
        arrivalTime: "10:45",
        gate: "A12",
        status: "准时",
    },
    [CONTENT_BLOCK_TYPES.FLIGHT_LIST]: [
        { flightNumber: "CA1234", route: "PEK → SHA", departureTime: "08:30", status: "准时" },
        { flightNumber: "CA5678", route: "SHA → SZX", departureTime: "14:20", status: "延误" },
        { flightNumber: "CA9012", route: "SZX → PEK", departureTime: "18:15", status: "准时" },
    ],
    [CONTENT_BLOCK_TYPES.FLIGHT_SCHEDULE]: {
        period: "2024年1月15日 - 2024年1月21日",
        totalFlights: 156,
        onTimeRate: "95.2%",
        averageDelay: "12分钟",
    },
    [CONTENT_BLOCK_TYPES.CONTACT]: {
        name: "张三",
        position: "运控主管",
        phone: "+86 138-0013-8000",
        email: "zhangsan@airline.com",
    },
    [CONTENT_BLOCK_TYPES.CONTACT_LIST]: [
        { name: "张三", position: "运控主管", phone: "+86 138-0013-8000", email: "zhangsan@airline.com" },
        { name: "李四", position: "调度员", phone: "+86 139-0013-9000", email: "lisi@airline.com" },
        { name: "王五", position: "签派员", phone: "+86 137-0013-7000", email: "wangwu@airline.com" },
    ],
    [CONTENT_BLOCK_TYPES.SIGNATURE]: {
        name: "系统管理员",
        title: "运行控制中心",
        company: "中国国际航空股份有限公司",
        phone: "+86 10-1234-5678",
        email: "admin@airchina.com",
    },
    [CONTENT_BLOCK_TYPES.SCHEDULE_FLIGHT_LIST]: [
        { flight_number: "CA1234", flight_date: "2024-01-15", departure_airport: "PEK", arrival_airport: "SHA", std: "08:30", sta: "10:45", aircraft_reg: "B-1234" },
        { flight_number: "CA5678", flight_date: "2024-01-15", departure_airport: "SHA", arrival_airport: "SZX", std: "14:20", sta: "16:35", aircraft_reg: "B-1234" },
        { flight_number: "CA9012", flight_date: "2024-01-15", departure_airport: "SZX", arrival_airport: "PEK", std: "18:15", sta: "20:30", aircraft_reg: "B-1234" },
    ],
    [CONTENT_BLOCK_TYPES.SCHEDULE_FLIGHT_LIST_WITH_COMPARISON]: {
        scheduleFlights: [
            { flight_number: "CA1234", flight_date: "2024-01-15", departure_airport: "PEK", arrival_airport: "SHA", std: "08:30", sta: "10:45", aircraft_reg: "B-1234", _comparisonStatus: "NO_CHANGE" },
            { flight_number: "CA5678", flight_date: "2024-01-15", departure_airport: "SHA", arrival_airport: "SZX", std: "14:20", sta: "16:35", aircraft_reg: "B-1234", _comparisonStatus: "CHANGED" },
            { flight_number: "CA9012", flight_date: "2024-01-15", departure_airport: "SZX", arrival_airport: "PEK", std: "18:15", sta: "20:30", aircraft_reg: "B-1234", _comparisonStatus: "ADDED" },
        ],
        removedFlights: [{ flight_number: "CA7890", flight_date: "2024-01-15", departure_airport: "PEK", arrival_airport: "CAN", std: "12:00", sta: "14:15", aircraft_reg: "B-5678", _comparisonStatus: "REMOVED", _isFromExecution: true }],
        summary: {
            totalScheduleFlights: 3,
            totalRemovedFlights: 1,
            addedCount: 1,
            changedCount: 1,
            removedCount: 1,
            unchangedCount: 1,
        },
    },
    [CONTENT_BLOCK_TYPES.SCHEDULE_INFO]: {
        name: "2024年1月航班计划",
        start_date: "2024-01-15",
        end_date: "2024-01-21",
        aircraft: { registration: "B-1234", aircraft_type: "B737-800" },
        flight_count: 42,
        status: "AIRLINE_CONFIRMED",
        description: "冬春航季常规航班计划",
    },
    [CONTENT_BLOCK_TYPES.OPERATION_FLIGHT_LIST]: [
        { flight_number: "CZ123", flight_date: "2024-01-15", departure_airport: "CAN", arrival_airport: "PEK", std: "2024-01-15T10:00:00Z", sta: "2024-01-15T13:00:00Z", aircraft_reg: "B-1234", stc_type: "PAX", status: "SCHEDULED" },
        { flight_number: "CZ456", flight_date: "2024-01-15", departure_airport: "PEK", arrival_airport: "SHA", std: "2024-01-15T15:30:00Z", sta: "2024-01-15T17:45:00Z", aircraft_reg: "B-5678", stc_type: "PAX", status: "DELAYED" },
        { flight_number: "CZ789", flight_date: "2024-01-15", departure_airport: "SHA", arrival_airport: "SZX", std: "2024-01-15T19:20:00Z", sta: "2024-01-15T21:35:00Z", aircraft_reg: "B-9012", stc_type: "PAX", status: "COMPLETED" },
    ],
    [CONTENT_BLOCK_TYPES.FLIGHT_WITH_PREDECESSOR]: {
        currentFlight: {
            flight_number: "CT107",
            flight_date: "2024-08-18",
            departure_airport: "HGH",
            arrival_airport: "ALA",
            std: "2024-08-18T20:55:00+08:00",
            sta: "2024-08-19T17:30:00+08:00",
            aircraft_reg: "9H-FLM",
            stc_type: "PAX"
        },
        predecessorFlight: {
            flight_number: "CT101",
            flight_date: "2024-08-18",
            departure_airport: "LGG",
            arrival_airport: "HGH",
            std: "2024-08-18T17:30:00+08:00",
            sta: "2024-08-18T19:55:00+08:00",
            aircraft_reg: "9H-FLM",
            stc_type: "PAX"
        }
    },
    [CONTENT_BLOCK_TYPES.CONTENT_BLOCK]: {
        title: "自定义内容块",
        content: "这是一个自定义的内容块，可以包含任意文本、图片或其他元素。",
    },
};

// 获取占位符显示配置的辅助函数
export const getContentBlockConfig = (type) => {
    return (
        CONTENT_BLOCK_DISPLAY_CONFIG[type] || {
            label: "未知类型",
            icon: "❓",
            color: "#8c8c8c",
            description: "未知的占位符类型",
        }
    );
};

// 获取内容块示例数据的辅助函数
export const getContentBlockSampleData = (type) => {
    return CONTENT_BLOCK_SAMPLE_DATA[type] || null;
};

// 验证占位符类型是否有效
export const isValidContentBlockType = (type) => {
    return Object.values(CONTENT_BLOCK_TYPES).includes(type);
};

// 获取业务上下文键
export const getContextKeyForContentBlock = (contentBlockType) => {
    return CONTENT_BLOCK_TO_CONTEXT_MAP[contentBlockType] || null;
};

// 内容块附件生成配置
export const CONTENT_BLOCK_ATTACHMENT_CONFIG = {
    [CONTENT_BLOCK_TYPES.SCHEDULE_FLIGHT_LIST]: {
        canGenerateAttachment: true,
        editable: false, // 有附件功能的不允许编辑，避免数据不一致
        dataScopeAdjustable: true,
        filterDimensions: [
            { key: "departure_date", label: "出发日期", field: "departure_date", type: "date", comparator: "range" },
            { key: "departure_airport", label: "始发机场", field: "departure_airport", type: "multiSelect", comparator: "in" },
            { key: "arrival_airport", label: "目的机场", field: "arrival_airport", type: "multiSelect", comparator: "in" },
        ],
        exportService: "schedule_flight_excel",
        defaultFilename: "航班计划列表.xlsx",
        attachmentType: "excel",
        buttonText: "生成Excel附件",
    },
    [CONTENT_BLOCK_TYPES.SCHEDULE_FLIGHT_LIST_WITH_COMPARISON]: {
        canGenerateAttachment: true,
        editable: false, // 有附件功能的不允许编辑，避免数据不一致
        exportService: "schedule_flight_excel",
        defaultFilename: "航班计划对比.xlsx",
        attachmentType: "excel",
        buttonText: "生成Excel附件",
    },
    [CONTENT_BLOCK_TYPES.FLIGHT_LIST]: {
        canGenerateAttachment: true,
        editable: false, // 有附件功能的不允许编辑，避免数据不一致
        exportService: "flight_excel",
        defaultFilename: "航班列表.xlsx",
        attachmentType: "excel",
        buttonText: "生成Excel附件",
    },
    [CONTENT_BLOCK_TYPES.OPERATION_FLIGHT_LIST]: {
        canGenerateAttachment: true,
        editable: false, // 有附件功能的不允许编辑，避免数据不一致
        exportService: "operation_flight_excel",
        defaultFilename: "执行航班列表.xlsx",
        attachmentType: "excel",
        buttonText: "生成Excel附件",
    },
    [CONTENT_BLOCK_TYPES.FLIGHT_WITH_PREDECESSOR]: {
        canGenerateAttachment: false,
        editable: true, // 无附件功能，允许编辑
    },
    [CONTENT_BLOCK_TYPES.SCHEDULE_INFO]: {
        canGenerateAttachment: false,
        editable: true, // 纯展示内容，允许编辑
    },
    [CONTENT_BLOCK_TYPES.SIGNATURE]: {
        canGenerateAttachment: false,
        editable: true, // 签名允许编辑
    },
    // 其他内容块暂不支持附件生成，但允许编辑
};

/**
 * 获取内容块的附件生成配置
 * @param {string} contentBlockType 内容块类型
 * @returns {object|null} 附件配置或null
 */
export const getContentBlockAttachmentConfig = (contentBlockType) => {
    return CONTENT_BLOCK_ATTACHMENT_CONFIG[contentBlockType] || null;
};

/**
 * 检查内容块是否支持生成附件
 * @param {string} contentBlockType 内容块类型
 * @returns {boolean} 是否支持生成附件
 */
export const canContentBlockGenerateAttachment = (contentBlockType) => {
    const config = CONTENT_BLOCK_ATTACHMENT_CONFIG[contentBlockType];
    const canGenerate = config && config.canGenerateAttachment === true;

    // 添加调试日志
    console.log("[canContentBlockGenerateAttachment] 检查内容块附件生成能力:", {
        contentBlockType,
        config,
        canGenerate,
        allConfigs: Object.keys(CONTENT_BLOCK_ATTACHMENT_CONFIG)
    });

    return canGenerate;
};

/**
 * 检查内容块是否可编辑
 * @param {string} contentBlockType 内容块类型
 * @returns {boolean} 是否可编辑（默认 true）
 */
export const isContentBlockEditable = (contentBlockType) => {
    const config = CONTENT_BLOCK_ATTACHMENT_CONFIG[contentBlockType];
    // 如果配置中明确设置了 editable，使用该值；否则默认为 true（允许编辑）
    return config?.editable !== false;
};

export const isContentBlockDataScopeAdjustable = (contentBlockType) => {
    const config = CONTENT_BLOCK_ATTACHMENT_CONFIG[contentBlockType];
    return config?.dataScopeAdjustable === true;
};

export const getContentBlockFilterDimensions = (contentBlockType) => {
    const config = CONTENT_BLOCK_ATTACHMENT_CONFIG[contentBlockType];
    return Array.isArray(config?.filterDimensions) ? config.filterDimensions : [];
};

/**
 * 航空货运专业术语英文化映射
 * 用于邮件编辑器内容块的英文显示
 */
export const AVIATION_TERMS_EN = {
    // 变更状态相关
    变更汇总: "Change Summary",
    总航班: "Total Flights",
    新增: "Added",
    变更: "Modified",
    删除: "Cancelled",
    无变化: "Unchanged",
    变更状态: "Change Status",

    // 航班信息相关
    航班号: "Flight No.",
    航线: "Route",
    日期: "Date",
    时间: "Time",
    起飞: "Departure",
    到达: "Arrival",
    机型: "Aircraft Type",
    注册号: "Registration",
    计划: "Schedule",
    航班: "Flight",
    航班列表: "Flight List",
    航班信息: "Flight Information",
    航班计划: "Flight Schedule",

    // 计划相关
    计划名称: "Schedule Name",
    执行周期: "Execution Period",
    状态: "Status",
    航班数量: "Number of Flights",
    执飞机型: "Operating Aircraft",
    计划基本信息: "Schedule Information",
    计划周期: "Schedule Period",

    // 表格列头 - 航空专业术语
    "A/C REG": "A/C REG", // Aircraft Registration
    飞机注册号: "A/C REG",
    Day: "Day", // Day of Week
    Flight: "Flight", // Flight Number
    DEP: "DEP", // Departure Airport
    ARR: "ARR", // Arrival Airport
    STD: "STD", // Scheduled Time of Departure
    STA: "STA", // Scheduled Time of Arrival
    STC: "STC", // Schedule Type Code
    BH: "BH", // Block Hours
    GT: "GT", // Ground Time
    Status: "Status", // Flight Status

    // 其他常用术语
    暂无航班数据: "No flight data available",
    暂无对比数据: "No comparison data available",
    无法获取业务数据: "Unable to retrieve business data",
    显示前: "Showing first",
    条记录: "records",
    共: "Total",
    个: "",
    至: "to",
    个航班: "flights",
    "[内容块]": "[Content Block]",
    未命名计划: "Unnamed Schedule",
    无计划信息: "No schedule information",
    计划信息: "Schedule Information",
    开始日期: "Start Date",
    结束日期: "End Date",
    未命名: "Unnamed",
    未知内容块类型: "Unknown content block type",
    序号: "No.",
    星期: "Day",
    航班性质: "STC",

    // 航食相关术语
    出港航班号: "Departure Flight No.",
    计划时间: "Scheduled Time",
    进港航班号: "Arrival Flight No.",
    预达时间: "Expected Arrival Time",
    配餐时间: "Catering Time",
    "出港航班号/航线": "Departure Flight/Route",
};

/**
 * 获取英文化的术语
 * @param {string} chineseTerm - 中文术语
 * @returns {string} 对应的英文术语，如果没有找到则返回原文
 */
export const getEnglishTerm = (chineseTerm) => {
    return AVIATION_TERMS_EN[chineseTerm] || chineseTerm;
};

/**
 * 批量替换文本中的中文术语为英文
 * @param {string} text - 包含中文术语的文本
 * @returns {string} 英文化后的文本
 */
export const translateToEnglish = (text) => {
    let translatedText = text;
    Object.entries(AVIATION_TERMS_EN).forEach(([chinese, english]) => {
        translatedText = translatedText.replace(new RegExp(chinese, "g"), english);
    });
    return translatedText;
};
